// Settings, Defaults, the follow-up days editor (Yehuda, Oct 29): its words and the check the server
// makes again (apps/server/src/follow-up.ts parseFollowUpDays).

export const followUpCopy = {
  row: 'Call the carrier when the renewal is not on the site',
  title: 'Follow-up days',
  sub: 'Defaults',
  days: 'Days before the renewal date',
  daysHint: 'The Record tells the VA to call the carrier from this day on.',
  daysError: 'Enter a whole number of days from 1 to 60.',
  saved: 'Follow-up days saved.',
  readOnly: 'Only the Manager and the Admin change the follow-up days.',
  somethingWrong: 'Something went wrong. Try again.',
  value: (days: number) => `${days === 1 ? '1 day' : `${days} days`} before the renewal date`,
} as const;

/** Whole days from 1 to 60, or null. */
export function followUpDaysOf(text: string): number | null {
  const t = text.trim();
  if (!/^\d{1,2}$/.test(t)) return null;
  const n = Number(t);
  return n >= 1 && n <= 60 ? n : null;
}

/** Why a save did not go through. */
export function followUpSaveError(error: string): string {
  return error === 'forbidden' ? followUpCopy.readOnly : followUpCopy.somethingWrong;
}
